import {setBlockType} from "prosemirror-commands";
import {schema} from "../../config/schema";
import {isBlockActive} from "../../../utils/isBlockActive";
import {EditorState} from "prosemirror-state";

export const setBlockTypeParagraph = setBlockType(schema.nodes.paragraph);

export const isNodeParagraph = isBlockActive(schema.nodes.paragraph)

export const nodeIsNotParagraph = (state: EditorState): boolean => {
    return !isNodeParagraph(state);
}
